module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-card-ffdd5936e1ef1e0ce7e54ae93cac2d2d.jpg";